module.exports = __webpack_public_path__ + "7fde8f452abaea9ea0cc3979ef20a17d.png";